import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { PartnerPortalLayout } from './PartnerPortalLayout';
import { DownloadIcon, SendIcon, EyeIcon, Building2Icon } from 'lucide-react';
export function PartnerProposalBuilderPage() {
  const [price, setPrice] = useState('25000');
  const [services, setServices] = useState({
    diagnostics: true,
    actionPlan: true,
    facilitator: false
  });
  return <PartnerPortalLayout data-id="element-4999">
      <div className="p-6 lg:p-10 max-w-7xl mx-auto h-[calc(100vh-4rem)] flex flex-col" data-id="element-5000">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-8 shrink-0" data-id="element-5001">
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} data-id="element-5002">
            <h1 className="font-serif-display text-3xl md:text-4xl font-bold text-[#0B1B3B] mb-2" data-id="element-5003">
              Proposal Builder
            </h1>
            <p className="text-slate-500" data-id="element-5004">
              Generate a co-branded retreat upgrade proposal for your booked
              groups.
            </p>
          </motion.div>
          <motion.div initial={{
          opacity: 0,
          y: 10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          delay: 0.1
        }} className="flex items-center gap-3" data-id="element-5005">
            <button className="flex items-center gap-2 px-4 py-2 bg-white border border-slate-200 rounded-lg text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors" data-id="element-5006">
              <DownloadIcon className="w-4 h-4" data-id="element-5007" />
              Export PDF
            </button>
            <button className="flex items-center gap-2 px-4 py-2 bg-[#0B1B3B] text-white rounded-lg text-sm font-medium hover:bg-[#0B1B3B]/90 transition-colors" data-id="element-5008">
              <SendIcon className="w-4 h-4" data-id="element-5009" />
              Send to Client
            </button>
          </motion.div>
        </div>

        <div className="flex flex-col lg:flex-row gap-8 flex-1 min-h-0" data-id="element-5010">
          {/* Configuration Panel */}
          <motion.div initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.2
        }} className="w-full lg:w-[35%] bg-white rounded-xl border border-slate-200 shadow-sm flex flex-col overflow-y-auto" data-id="element-5011">
            <div className="p-6 border-b border-slate-100" data-id="element-5012">
              <h2 className="font-serif-display text-xl font-bold text-[#0B1B3B]" data-id="element-5013">
                Configuration
              </h2>
            </div>
            <div className="p-6 space-y-8" data-id="element-5014">
              {/* SKU Selection */}
              <div data-id="element-5015">
                <div className="border border-amber-500 bg-amber-50/30 rounded-lg p-4 relative" data-id="element-5016">
                  <div className="absolute top-4 left-4 w-4 h-4 rounded-full border-4 border-amber-500 bg-white" data-id="element-5017" />
                  <div className="pl-8" data-id="element-5018">
                    <div className="font-bold text-[#0B1B3B] mb-1" data-id="element-5019">
                      Executive Alignment Retreat
                    </div>
                    <div className="text-xs text-slate-500" data-id="element-5020">
                      Resolving tensions & unifying vision
                    </div>
                  </div>
                </div>
              </div>

              {/* Pricing */}
              <div data-id="element-5021">
                <label className="block text-[10px] font-bold text-[#0B1B3B] uppercase tracking-wider mb-2" data-id="element-5022">
                  Upgrade Pricing
                </label>
                <div className="relative" data-id="element-5023">
                  <span className="absolute left-4 top-1/2 -translate-y-1/2 text-slate-400 font-medium" data-id="element-5024">
                    $
                  </span>
                  <input type="text" value={price} onChange={e => setPrice(e.target.value)} className="w-full pl-8 pr-4 py-3 bg-slate-50 border border-slate-200 rounded-lg text-sm font-medium focus:ring-2 focus:ring-amber-500/20 focus:border-amber-500 transition-colors outline-none" data-id="element-5025" />
                </div>
                <div className="text-xs text-slate-400 mt-2" data-id="element-5026">
                  Recommended: $25,000
                </div>
              </div>

              {/* Included Services */}
              <div data-id="element-5027">
                <label className="block text-[10px] font-bold text-[#0B1B3B] uppercase tracking-wider mb-3" data-id="element-5028">
                  Included Services
                </label>
                <div className="space-y-3" data-id="element-5029">
                  <label className="flex items-center gap-3 cursor-pointer" data-id="element-5030">
                    <input type="checkbox" checked={services.diagnostics} onChange={e => setServices({
                    ...services,
                    diagnostics: e.target.checked
                  })} className="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-500" data-id="element-5031" />
                    <span className="text-sm text-slate-700" data-id="element-5032">
                      Pre-Retreat AI Diagnostics
                    </span>
                  </label>
                  <label className="flex items-center gap-3 cursor-pointer" data-id="element-5033">
                    <input type="checkbox" checked={services.actionPlan} onChange={e => setServices({
                    ...services,
                    actionPlan: e.target.checked
                  })} className="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-500" data-id="element-5034" />
                    <span className="text-sm text-slate-700" data-id="element-5035">
                      90-Day Post-Retreat Action Plan
                    </span>
                  </label>
                  <label className="flex items-center gap-3 cursor-pointer" data-id="element-5036">
                    <input type="checkbox" checked={services.facilitator} onChange={e => setServices({
                    ...services,
                    facilitator: e.target.checked
                  })} className="w-4 h-4 rounded border-slate-300 text-amber-500 focus:ring-amber-500" data-id="element-5037" />
                    <span className="text-sm text-slate-700" data-id="element-5038">
                      On-site Executive Facilitator
                    </span>
                  </label>
                </div>
              </div>
            </div>
          </motion.div>

          {/* Live Preview */}
          <motion.div initial={{
          opacity: 0,
          x: 20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3
        }} className="w-full lg:w-[65%] bg-slate-100 rounded-xl border border-slate-200 flex flex-col overflow-hidden relative" data-id="element-5039">
            <div className="absolute top-4 right-4 z-10 bg-white rounded-full px-3 py-1.5 shadow-sm border border-slate-200 flex items-center gap-1.5" data-id="element-5040">
              <EyeIcon className="w-3.5 h-3.5 text-slate-400" data-id="element-5041" />
              <span className="text-[10px] font-bold text-slate-600 uppercase tracking-wider" data-id="element-5042">
                Live Preview
              </span>
            </div>

            <div className="flex-1 overflow-y-auto p-4 md:p-8 flex justify-center" data-id="element-5043">
              {/* Proposal Document Mockup */}
              <div className="bg-white w-full max-w-[800px] shadow-xl border border-slate-200 min-h-[800px] flex flex-col" data-id="element-5044">
                {/* Hero */}
                <div className="bg-[#0B1B3B] text-white p-12 relative overflow-hidden" data-id="element-5045">
                  <div className="absolute inset-0 bg-[url('https://images.unsplash.com/photo-1540541338287-41700207dee6?ixlib=rb-4.0.3&auto=format&fit=crop&w=2000&q=80')] opacity-20 bg-cover bg-center mix-blend-overlay" data-id="element-5046" />
                  <div className="relative z-10" data-id="element-5047">
                    <div className="flex justify-between items-start mb-16" data-id="element-5048">
                      <div data-id="element-5049">
                        <div className="font-serif-display text-2xl font-bold" data-id="element-5050">
                          Moon Palace Cancún
                        </div>
                        <div className="text-[10px] font-bold text-amber-500 uppercase tracking-[0.2em] mt-1" data-id="element-5051">
                          Signature Retreats
                        </div>
                      </div>
                      <Building2Icon className="w-10 h-10 text-white/20" data-id="element-5052" />
                    </div>

                    <div className="text-[10px] font-bold text-amber-500 uppercase tracking-[0.2em] mb-4" data-id="element-5053">
                      Premium Upgrade Proposal
                    </div>
                    <h1 className="font-serif-display text-4xl md:text-5xl font-bold mb-6" data-id="element-5054">
                      Executive Alignment Retreat
                    </h1>
                    <p className="text-lg text-slate-300" data-id="element-5055">
                      Prepared exclusively for Helix Health
                    </p>
                  </div>
                </div>

                {/* Body */}
                <div className="p-12 flex-1" data-id="element-5056">
                  <div className="max-w-2xl" data-id="element-5057">
                    <div className="flex items-center gap-3 mb-4" data-id="element-5058">
                      <div className="w-8 h-8 rounded-full bg-amber-50 flex items-center justify-center" data-id="element-5059">
                        <div className="w-3 h-3 rounded-full border-2 border-amber-500" data-id="element-5060" />
                      </div>
                      <h3 className="text-[10px] font-bold text-slate-400 uppercase tracking-[0.2em]" data-id="element-5061">
                        Strategic Objective
                      </h3>
                    </div>
                    <p className="text-slate-600 leading-relaxed mb-12" data-id="element-5062">
                      To accelerate post-merger integration by aligning the
                      executive team on a unified vision, resolving operational
                      tensions, and establishing a shared culture framework.
                    </p>

                    <div className="grid grid-cols-2 gap-8 mb-12" data-id="element-5063">
                      <div data-id="element-5064">
                        <div className="text-3xl font-serif-display font-bold text-[#0B1B3B] mb-1" data-id="element-5065">
                          ${Number(price).toLocaleString()}
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-5066">
                          Incremental Investment
                        </div>
                      </div>
                      <div data-id="element-5067">
                        <div className="text-3xl font-serif-display font-bold text-[#0B1B3B] mb-1" data-id="element-5068">
                          120
                        </div>
                        <div className="text-xs text-slate-500" data-id="element-5069">
                          Participating Executives
                        </div>
                      </div>
                    </div>

                    <div className="space-y-4" data-id="element-5070">
                      <h4 className="font-serif-display text-xl font-bold text-[#0B1B3B] mb-4" data-id="element-5071">
                        Included in this upgrade:
                      </h4>
                      {services.diagnostics && <div className="flex items-start gap-3" data-id="element-5072">
                          <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 shrink-0" data-id="element-5073" />
                          <p className="text-sm text-slate-600" data-id="element-5074">
                            Pre-retreat AI diagnostics to identify hidden team
                            tensions and alignment gaps before arrival.
                          </p>
                        </div>}
                      {services.actionPlan && <div className="flex items-start gap-3" data-id="element-5075">
                          <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 shrink-0" data-id="element-5076" />
                          <p className="text-sm text-slate-600" data-id="element-5077">
                            90-day post-retreat action plan with automated
                            accountability check-ins via the event hub.
                          </p>
                        </div>}
                      {services.facilitator && <div className="flex items-start gap-3" data-id="element-5078">
                          <div className="w-1.5 h-1.5 rounded-full bg-amber-500 mt-2 shrink-0" data-id="element-5079" />
                          <p className="text-sm text-slate-600" data-id="element-5080">
                            Dedicated on-site executive facilitator to guide the
                            strategic sessions.
                          </p>
                        </div>}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </motion.div>
        </div>
      </div>
    </PartnerPortalLayout>;
}